import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../shared-components/user/user.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-card-container',
    templateUrl: './card-container.component.html',
    styleUrls: ['./card-container.component.css']
})
export class CardContainerComponent implements OnInit {
    cardsLeft: any[];
    cardsRight: any[];
    cardsSorted = false;

    constructor(private userService: UserService) {
    }

    ngOnInit() {
    }

    refreshCards() {
        const cards = _.cloneDeep(this.userService.cards);
        this.userService.cards = [];
        this.userService.cards = cards;
        this.filterCards(cards);
    }

    filterCards(cards) {
        this.cardsSorted = false;
        if (this.userService.userType != 1) {
            // If the user is not staff remove the staff only cards
            cards = cards.filter(card => !card.staffOnly);
        }
        // Sort cards into left and right columns
        this.cardsLeft = cards.filter(card => card.columnPosition == 'L' && card.display != 'Off');
        this.cardsRight = cards.filter(card => card.columnPosition == 'R' && card.display != 'Off');
        // Sort cards in each column based on position
        this.cardsLeft = this.cardsLeft.sort(function (a, b) {
            if (a.position < b.position) {
                return -1;
            }
            if (a.position > b.position) {
                return 1;
            }
        });
        this.cardsRight = this.cardsRight.sort(function (a, b) {
            if (a.position < b.position) {
                return -1;
            }
            if (a.position > b.position) {
                return 1;
            }
        });
        this.cardsSorted = true;
    }
}
